export default __webpack_public_path__ + "static/media/3.a6466938.jpg";